export const REPORT_QUIZ_DOMAINS = ['quiz.lingopass-edu.com/pl'];
